import { useEffect, useState } from "react";
import DisplayExams from "../../components/DisplayItems/DisplayExams";

import SearchBar from "../../components/Search/SearchBar";
import { getAllExams } from "../../endpoints/Assessment/functions";
import { IconButton } from "@mui/material";
import { Add } from "@mui/icons-material";
const HomePage = (props) => {
  const [exams, setExams] = useState([]);
  const [allExams, setAllExams] = useState([]);
  const [loading, setLoading] = useState(false);
  async function getExams(unfiltered) {
    if (unfiltered) {
      setLoading(true);
      try {
        let data = await getAllExams(props.token);
        setExams(data);
        setAllExams(data);
      } catch (error) {
        console.log("Error at getExams", error);
      }
      setLoading(false);
    } else setExams(allExams);
  }
  useEffect(() => {
    getExams(true);
    // eslint-disable-next-line
  }, [props.token]);
  return (
    <div className="page-box">
      <div>
        <SearchBar
          exams={exams}
          allExams={allExams}
          setExams={setExams}
          getExams={getExams}
          user={props.user}
          token={props.token}
        />
      </div>{" "}
      <DisplayExams
        loading={loading}
        user={props.user}
        token={props.token}
        getExams={getExams}
        exams={exams}
      />
      <IconButton
        href="/exams/new"
        className="mobile button-link fab"
        color="primary"
        sx={{
          position: "fixed",
          bottom: 2,
          margin: "8px",
          right: 2,
          backgroundColor: "var(--blue) !important",
          width: "45px",
          height: "45px",
        }}
        disableFocusRipple
      >
        <Add color="white" sx={{ color: "white !important" }} />
      </IconButton>
    </div>
  );
};

export default HomePage;
